import React, { useState } from 'react';
import SupportChatbot from '../components/SupportChatbot';

const ContactUs = () => {
  const [isChatbotOpen, setIsChatbotOpen] = useState(true);

  return (
    <div className="w-full h-full p-6">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Contact Support</h1>
        <p className="text-gray-600 mb-8">
          Get help from our support team. Use the chat window to start a conversation.
        </p>

        <div className="bg-white rounded-lg shadow-md p-6 mb-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Support Options</h2>
          
          <div className="grid md:grid-cols-2 gap-6">
            <div className="border border-gray-200 rounded-lg p-4">
              <h3 className="font-semibold text-gray-900 mb-2">Live Chat</h3>
              <p className="text-gray-600 text-sm mb-4">
                Chat with our support team in real-time. Available 24/7.
              </p>
              <button
                onClick={() => setIsChatbotOpen(true)}
                className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors"
              >
                Open Chat
              </button>
            </div>

            <div className="border border-gray-200 rounded-lg p-4">
              <h3 className="font-semibold text-gray-900 mb-2">Email Support</h3>
              <p className="text-gray-600 text-sm mb-4">
                Send us an email and we'll respond within 24 hours.
              </p>
              <a
                href="mailto:support@agenticpractice.com"
                className="text-blue-600 hover:text-blue-700 underline"
              >
                support@agenticpractice.com
              </a>
            </div>
          </div>
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
          <h3 className="font-semibold text-blue-900 mb-2">Need Immediate Help?</h3>
          <p className="text-blue-800 text-sm">
            For urgent issues, please use the live chat feature. Our support team is available 24/7 to assist you.
          </p>
        </div>
      </div>

      {/* Support Chatbot */}
      <SupportChatbot isOpen={isChatbotOpen} onClose={() => setIsChatbotOpen(false)} />
    </div>
  );
};

export default ContactUs;

